export default __webpack_public_path__ + "static/media/sindrome_coronario_agudo.05c90005.pdf";